import React, {} from "react"
import {
   FaLayerGroup,
   // FaTimes
} from 'react-icons/fa';
import '../../../css/InfluencerUpload.css'
import make_content_block from './make_content_block';
import get_str_from_tier_num from './get_str_from_tier_num';

export default function make_content_with_overlay(content_info, outer_div_class_name) {
   var tier_div_class = "inf_scroll_page_tier" + content_info['tier'] + "_div";
   var content_tier_str = get_str_from_tier_num(content_info['tier']);
   var block_content = make_content_block(content_info)
   return (
      <div className="content_info_scroll_content" >
         {block_content}
         <div className="content_upper_black_gradient_3"></div>
         <div className={tier_div_class}>
            <div className="inf_scroll_page_tier_text">
               TIER
            </div>
            <div className="inf_scroll_page_tier_type_text">
               {content_tier_str}
            </div>
            <div className="inf_scroll_page_tier_symbol">
               <FaLayerGroup/>
            </div>
         </div>
      </div>
   )
}
